import { useCallback, useEffect, useMemo, useRef, useState } from "react";

export const DEFAULT_FILTER_DEBOUNCE_MS = 400;

export function useDebouncedValue<T>(
  value: T,
  delay = DEFAULT_FILTER_DEBOUNCE_MS,
): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebouncedValue(value), delay);
    return () => window.clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}

export function useFetchRequestGuard() {
  const requestIdRef = useRef(0);

  const beginRequest = useCallback(() => {
    requestIdRef.current += 1;
    return requestIdRef.current;
  }, []);

  const isStaleRequest = useCallback(
    (requestId: number) => requestId !== requestIdRef.current,
    []
  );

  // Stable object reference — safe in useCallback/useEffect dependency arrays.
  return useMemo(
    () => ({ beginRequest, isStaleRequest }),
    [beginRequest, isStaleRequest]
  );
}
